var map = {
	"./404.png": "bhgG",
	"./cloud.png": "X842",
	"./footerlogo.png": "ksn0",
	"./loading.gif": "3+W1",
	"./no-recommend.png": "NJLW",
	"./yun.png": "kWZG",
	"./未标题-2.png": "klqU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "deFR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*$
// module id = deFR
// module chunks = 17